export default {"src":"/_next/static/media/skillzLogo.7993d46a.svg","height":2772,"width":3000,"blurWidth":0,"blurHeight":0};